import StonecodeFileServiceModel from '@models/website/StonecodeFileServiceModel';
import StonecodeFilePolicyModel  from '@models/website/StonecodeFilePolicyModel';
import doc                       from '@widesk-core/decorators/doc';
import WebsiteServiceModel       from '@/models/WebsiteServiceModel';
import Blamable                  from '@/models/traits/Blamable';
import { Addable }               from '@widesk-core/decorators/addable';
import { Editable }              from '@widesk-core/decorators/editable';
import { Deletable }             from '@widesk-core/decorators/deletable';
import { Timestampable }         from '@widesk-core/decorators/timestampable';

@doc.urnResource('stonecode_file_type')
@doc.path('/stonecode_file_types/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractStonecodeFileTypeModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		'service': id;
		'service.serviceUrn': Urn;
		'policy': id;
		'policy.reference': Website_StonecodeFilePolicyReference;
		'reference': Website_StonecodeFileTypeReference;
		'urnMask': id;
		'deprecated': string;
		'system': string;
	};

	declare private _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
		label: string;
		deprecated: string;
	};

	@doc.model(StonecodeFileServiceModel)
	declare service: StonecodeFileServiceModel;
	@doc.model(StonecodeFilePolicyModel) declare policy: StonecodeFilePolicyModel;
	@doc.string declare reference: Website_StonecodeFileTypeReference;
	@doc.string declare label: string;
	@doc.string declare urnMask: string;
	@doc.number declare maxPerSource: number;
	@doc.number declare maxSize: number;
	@doc.string declare kind: string;
}

interface AbstractStonecodeFileTypeModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractStonecodeFileTypeModel;
